var Aneox;
(function (Aneox) {
  'use strict';

  var Vintages = (function () {

    var inlineImg;
    var summary;
    var selector;

    var vintages;
    var currentVintage;

    var vintageButtons;
    var vintagePageElement;
    var vintagePageTextElement = $('#vintage-page-text');
    var vintagePhotoElement;
    var vintagePageTextElement;
    var vintageTitleYearElement;
    var vintageDownloadButton;

    var localeId;

    var self;

    function Vintages(locale) {

      inlineImg = $('#vintage-inline-img');
      summary = $('#vintage-summary');
      selector = $('#vintage-selector');

      vintageButtons = $('.js-vintage-button');
      vintagePageElement = $('#vintage');
      vintagePhotoElement = $('#vintage-photo');
      vintagePageTextElement = $('#vintage-page-text');
      vintageTitleYearElement = $('#vintage-title-year');
      vintageDownloadButton = $('#vintage-download');

      self = this;

      /*vintages = _.sortBy(Aneox.Data.Data.vintages, [function(vintage) {
        return -vintage.id;
      }]);*/
        
      /*vintages = app.dataVintages;    
        

      locale.bind('localeChange', function(locale) {
        updateScreen(vintages[0], locale);
        localeId = locale;

        selector.off().change(function() {
          updateScreen(_.find(vintages, { id: this.value }), locale);
        });
      });

      selector.append(vintages.reduce(function(acc, vintage) {
        return acc + '<option>' + vintage.id + '</option>';
      }, ''));*/

    }

    Vintages.prototype.setData = function(locale){
        vintages = app.dataVintages;
        updateScreen(vintages[0], locale);
        localeId = locale;

        selector.off().change(function() {
            var dataVintage = _.find(vintages, { id: this.value });
          updateScreen(dataVintage, locale);
        });
        
        selector.empty().append(vintages.reduce(function(acc, vintage) {
        return acc + '<option value="'+ vintage.id +'">' + vintage.name + '</option>';
      }, ''));
    }  
      
    Vintages.prototype.openPage = function(id) {
      currentVintage = +id;
      populatePage(id, localeId);
      $('#page-wrapper').addClass('noscroll');
      vintagePageElement.fadeIn();
    };

    Vintages.prototype.closePage = function() {
      currentVintage = null;
      vintagePageElement.fadeOut();
      $('#page-wrapper').removeClass('noscroll');
    }

    function updateScreen(vintage, locale) {
      inlineImg.attr('src', vintage.img);
      
      var vintageLocale = _.find(vintage.locales, { locale: locale });
      summary.html(vintageLocale.summary);
      vintageButtons.off().click(function() {
        self.openPage(vintage.id);
      });
    }

    function populatePage(id, locale) {
      
      var vintage = _.find(app.dataVintages, { id: id });
      var vintageLocale = _.find(vintage.locales, { locale: locale });  
        
      //var vintagePDFPath =  (location.origin.length > 0)? location.origin +'/'+Aneox.Data.Config.desktopurl : 'http://www.'+Aneox.Data.Config.desktopurl;   
      var vintagePDFPath =  'http://www.'+Aneox.Data.Config.desktopurl;   
        
        
      vintageDownloadButton.attr('href', vintagePDFPath+'/pdf/vintage/' + vintageLocale.nid );
        
        //vintageDownloadButton.attr('href', 'vintage.php?vintage=' + id + '&locale=' + locale);

      //var vintage = _.find(Aneox.Data.Data.vintages, { id: id });
      //var vintageLocale = _.find(vintage.locales, { locale: locale });
      //vintageTitleYearElement.text(vintage.id);
      vintageTitleYearElement.text(vintage.name);
      vintagePhotoElement.attr('data-bg', vintage.img)
      .removeClass('lazyloaded').addClass('lazyload');
      vintagePageTextElement.html(vintageLocale.text);
    }

    Vintages.prototype.next = function() {
      //if (_.findIndex(Aneox.Data.Data.vintages, { id: '' + currentVintage }) === 0) {
      if (_.findIndex(app.dataVintages, { id: '' + currentVintage }) === 0) {
        currentVintage = +app.dataVintages[app.dataVintages.length - 1].id;
      } else {
        currentVintage++;
      }
      updateScreen(_.find(app.dataVintages, { id: '' + currentVintage }), localeId);
      populatePage('' + currentVintage, localeId);
    };

    Vintages.prototype.previous = function() {
      //if (_.findIndex(Aneox.Data.Data.vintages, { id: '' + currentVintage }) ===
      if (_.findIndex(app.dataVintages, { id: '' + currentVintage }) ===
        app.dataVintages.length - 1)   {
        currentVintage = +app.dataVintages[0].id;
      } else {
        currentVintage--;
      }
      updateScreen(_.find(app.dataVintages, { id: '' + currentVintage }), localeId);
      populatePage('' + currentVintage, localeId);
    }

    return Vintages;

  })();

  Aneox.Vintages = Vintages;
})(Aneox || (Aneox = {}));